/** Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): liga o índice e a camada do mapa. */
import { useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { RaiosLayerManager } from './layer';
import { iniciarSyncRaios, registrarNovaTentativa } from './sync';

export { refreshRaios } from './sync';

export function useRaiosLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => iniciarSyncRaios(), []);

  useEffect(() => {
    if (!map) return;
    const manager = new RaiosLayerManager(map);
    registrarNovaTentativa(() => manager.tentarDeNovo());
    return () => {
      registrarNovaTentativa(null);
      manager.dispose();
    };
  }, [map]);
}
